export default function WestonHeroSection() {
  return (
    <section className="relative bg-[#1A365D] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20beautiful%20master-planned%20suburban%20community%20with%20manicured%20green%20landscapes%2C%20elegant%20homes%2C%20winding%20roads%2C%20and%20palm%20trees%20under%20a%20bright%20blue%20sky%2C%20warm%20Florida%20sunlight%2C%20professional%20real%20estate%20photography%20style%2C%20clean%20and%20affluent%20neighborhood&width=1600&height=700&seq=weston-hero-1&orientation=landscape"
          alt="Weston Florida master-planned community aerial view"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A365D]/95 via-[#1A365D]/80 to-[#1A365D]/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1.5 rounded-full mb-5 whitespace-nowrap">
            <i className="ri-shield-check-line"></i> Registered U.S. Department of State Courier
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Expedited Passport Services in <span className="text-[#F6C344]">Weston, FL</span>
          </h1>
          <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-8 max-w-xl">
            Emergency and expedited passport processing for Weston travelers — as fast as 24 hours. Serving Bonaventure, Weston Hills, and families throughout western Broward County.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4 mb-10">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 text-white/80 hover:text-[#F6C344] font-semibold text-base transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-white/50 text-xs">
            <span className="flex items-center gap-1.5"><i className="ri-star-fill text-[#F6C344]"></i> A+ BBB Rating</span>
            <span className="flex items-center gap-1.5"><i className="ri-time-line text-[#F6C344]"></i> 24-Hour Processing Available</span>
            <span className="flex items-center gap-1.5"><i className="ri-map-pin-line text-[#F6C344]"></i> Serving All of Broward County</span>
          </div>
        </div>
      </div>
    </section>
  );
}